import React, { useEffect, createElement, Component } from 'react';
import { Toaster } from 'sonner';
import { CONSTANTS } from './utils/constants';
// Components
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel Initialization
    try {
      // @ts-ignore - fbq is injected by the pixel script usually, we mock it here if not present
      if (typeof window !== 'undefined') {
        !function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        // @ts-ignore
        window.fbq('init', CONSTANTS.META_PIXEL_ID);
        // @ts-ignore
        window.fbq('track', 'PageView');
      }
    } catch (error) {
      console.error('Error initializing Meta Pixel:', error);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <StickyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProof data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <EmotionalTransition data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <WhatIsIncluded data-id="element-8" />
        <BonusSection data-id="element-9" />
        <UrgencySection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTASection data-id="element-15" />
      </main>

      <Footer data-id="element-16" />

      {/* Global components */}
      <Toaster position="bottom-left" data-id="element-17" />
      <PurchasePopup data-id="element-18" />
    </div>;
}